/**
 * Cloud implementation of the shared UserApi. The cloud backend already uses the
 * canonical field names (name, role), so mapping is mostly pass-through. Cloud does
 * not paginate users (returns the full list) and has no is_active concept.
 */
import type { UserApi, User } from '@trinetra/shared';
import { userService } from '../services/user.service';

export const cloudUserApi: UserApi = {
  async list() {
    const data = await userService.list();
    return { data: (Array.isArray(data) ? data : []) as User[], meta: null };
  },
  get: (id) => userService.get(id),
  create: (data) => userService.create(data as any),
  update: (id, data) => userService.update(id, data as any),
  delete: (id) => userService.delete(id),
  listRoles: () => userService.getRolesList(),
};
